import { HttpClient, ListParams } from './http-client';
import Paginate from '../interfaces/paginate';
import { Observable, Subject, Subscriber } from 'rxjs';
import {
  AnimalEvent,
  AnimalEventsCalendar,
  AnimalEventTable,
  AnimalEventTableShow,
} from '../interfaces/animal-event';
import FormFile from '../interfaces/file';
interface Option {
  label: string;
  value: string;
}
export class AnimalEventService extends HttpClient {
  indexCalendar(
    farmId: string,
    params?: ListParams
  ): Observable<AnimalEventsCalendar> {
    return this.get<AnimalEventsCalendar>(
      `/api/farms/${farmId}/livestock/animal-events/index-calendar`,
      { ...params }
    );
  }
  index(
    farmId: string,
    params?: ListParams,
    getAll?: boolean
  ): Observable<Paginate<AnimalEventTable>> {
    return this.get<Paginate<AnimalEventTable>>(
      `/api/farms/${farmId}/livestock/animal-events`,
      { ...params, getAll }
    );
  }

  show(farmId: string, id: string): Observable<AnimalEvent> {
    return this.get<AnimalEvent>(
      `/api/farms/${farmId}/livestock/animal-events/${id}`
    );
  }
  showAllEvents(
    farmId: string,
    params?: ListParams
  ): Observable<Paginate<AnimalEventTableShow>> {
    return this.get<Paginate<AnimalEventTableShow>>(
      `/api/farms/${farmId}/livestock/animal-events/all-events`,
      params
    );
  }

  store(farmId: string, data: any): Observable<AnimalEvent> {
    return this.post<AnimalEvent>(
      `/api/farms/${farmId}/livestock/animal-events`,
      data
    );
  }

  update(farmId: string, id: string, data: any): Observable<AnimalEvent> {
    return this.put<AnimalEvent>(
      `/api/farms/${farmId}/livestock/animal-events/${id}/`,
      data
    );
  }

  destroy(farmId: string, id: string): Observable<AnimalEvent> {
    return this.delete<AnimalEvent>(
      `/api/farms/${farmId}/livestock/animal-events/${id}/`
    );
  }

  destroyFile(farmId: string, id: string, fileId: string): void {
    this.delete<void>(
      `/api/farms/${farmId}/livestock/animal-events/file/${id}/${fileId}`
    );
  }

  uploadFile(
    farmId: string,
    file: File,
    progress: Subscriber<ProgressEvent> | Subject<ProgressEvent>
  ): Observable<FormFile> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.post<FormFile>(
      `/api/farms/${farmId}/livestock/animal-events/upload`,
      formData,
      {
        headers: { 'Content-Type': null },
        progressSubscriber: progress,
      }
    );
  }

  download(farmId: string, animalEventId: string, fileId: string): Observable<Blob> {
    return this.get<Blob>(
      `/api/farms/${farmId}/livestock/animal-events/${animalEventId}/files/${fileId}`,
      {},
      { responseType: 'blob' }
    );
  }

  animalEventAnimalDestroy(farmId: string, id: string) {
    return this.delete(
      `/api/farms/${farmId}/livestock/animal-events/animal/${id}`
    );
  }

  animalEventProductDestroy(farmId: string, id: string) {
    return this.delete(
      `/api/farms/${farmId}/livestock/animal-events/product/${id}`
    );
  }

  syncAnimals(farmId: string, params?: ListParams): Observable<void> {
    return this.post<null>(
      `/api/farms/${farmId}/livestock/animal-events/sync`,
      params
    );
  }

  events(farmId: string, params?: ListParams): Observable<Option[]> {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-events/event-list`,
      params
    );
  }

  subEvents(farmId: string, params?: ListParams): Observable<Option[]> {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-events/sub-event-list`,
      params
    );
  }

  subEventsByAnimal(farmId: string, params?: ListParams): Observable<Option[]> {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-events/sub-event-list-by-animal`,
      params
    );
  }

  barns(farmId: string, params?: ListParams): Observable<Option[]> {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-events/barn-filter-values`,
      params
    );
  }

  species(farmId: string, params?: ListParams) {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-events/species-filter-values`,
      params
    );
  }

  exportXls(farmId: string, params?: ListParams): Observable<object> {
    return this.export(`/api/farms/${farmId}/livestock/animal-events`, params);
  }

  animalEids(farmId: string, params?: ListParams): Observable<Option[]> {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-events/animal-eid-filter-values`,
      params
    );
  }

  setDone(farmId: string, eventIds: string[]) {
    return this.put(`/api/farms/${farmId}/livestock/animal-events/set-done`, {
      'event_ids': eventIds,
    });
  }

  furthestScheduledFarmAnimalEvent(farmId: string): Observable<AnimalEvent> {
    return this.get(
      `/api/farms/${farmId}/livestock/animal-events/furthest-scheduled-event`
    );
  }
}
